import { render, staticRenderFns } from "./EmSppStorageLocList.vue?vue&type=template&id=b16e88b0&"
import script from "./EmSppStorageLocList.vue?vue&type=script&lang=js&"
export * from "./EmSppStorageLocList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports